import moment from "moment"

export default {
    convertMinutesToHoursMinutes(minutes) {
        const hoursMinutes = `${minutes < 0 ? '-' : ''}${Math.abs(minutes / 60) ^ 0}` + ':' + ('0' + minutes % 60).slice(-2)
        return hoursMinutes;
    },
    formatDate(dateString) {
        return moment(dateString).format('dddd, D MMM YYYY');
    },
    formatCurrentDate() {
      return moment().format('DD MMM YYYY');
    },
    formatTime(dateString) {
        return moment(dateString).format('h:mm a');
    },
    formatIsoTimeNow() {
        return moment().format('HH:mm')
    },
    formatIsoTimeToTime(isoTimeString) {
        return moment(isoTimeString, "HH:mm").format('h:mm a');
    },
    formatPeriod(fromDateString, toDateString) {
        return `${this.formatTime(fromDateString)} - ${this.formatTime(toDateString)}`;
    },
    formatLocation(area, seat, floor) {
        return `${area}, Level ${floor}`;
    },
    // formatLocation(area, seat, floor) {
    //     return `${area} - ${seat}, Level ${floor}`;
    // },
    formatLocationShort(area, seat, floor) {
        return `${area} - ${seat}, L${floor}`;
    },
    formatBookingStatus(actions, isVisitBooking) {
        let bookingStatus = isVisitBooking ? {
            text: null,
            icon: null,
            color: null
        } : {
            text: "Check-in no later than 14 minutes from your booking start time.",
            // text: "Check-in required",
            icon: "mdi-map-marker",
            color: ""
        };

        if (actions.includes("ManualFullCancel")) {
            bookingStatus = {
                text: "Cancelled",
                icon: "mdi-close-thick",
                color: "red"
            };
        } else if (actions.includes("ManualPartialCancel")) {
            bookingStatus = {
                text: "Partially cancelled",
                icon: "mdi-close-outline",
                color: "red"
            };
        } else if (actions.includes("AutoPartialCancel")) {
            bookingStatus = {
                text: "This booking has been cancelled as you did not check-in, 15 minutes has been deducted from your daily quota.",
                // text: "Partially auto-cancelled",
                icon: "mdi-close-outline",
                color: "red"
            };
        } else if (
            actions.includes("BookAndCheckIn") ||
            actions.includes("AutoCheckIn") ||
            actions.includes("ManualCheckIn") ||
            actions.includes("OverBookAndCheckIn")
        ) {
            bookingStatus = {
                text: "Checked in",
                icon: "mdi-check-decagram",
                color: "orange"
            };
        }

        return bookingStatus;
    }
}
